import React,{useState,useEffect} from 'react'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import {Row,Col,Modal,Button} from 'react-bootstrap'
import {AiOutlinePlus} from 'react-icons/ai'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TextField from '@mui/material/TextField';
import ReactPaginate from 'react-paginate';
import moment from 'moment'

import { menumgmtApi,menumgmtmodelApi } from '../../../utils/AdminDashApi/MenuMgmtApi'
import { roleMgmtApi } from '../../../utils/AdminDashApi/RoleMgmtApi'
import { clsteacherAssignApi } from '../../../utils/AdminDashApi/ClassTeachAssignmentApi'
import { optionsCampus, optionsPeriod, optionsdept } from '../../Helper'
import { BsSearch } from 'react-icons/bs'
import { AttendanceReportApi } from '../../../utils/AdminDashApi/AttendanceReportApi'

const AttendancereportCompmb = () => {
    const [activefrom,setactivefrom] = useState("")
    const [activeto,setactiveTo] = useState("")
    const [show,setShow] = useState(10)
  
    
   
    const [examDrp,setExamdrp] = useState("")
   
    
  
   const optionsClass = [
      {   id:1,
          opt:'Select Class'
      },
      {   id:2,
          opt:'Starter'
      },
      {   id:3,
          opt:'Playgroup'
      },
      {   id:3,
          opt:'Nursery'
      },
      {   id:4,
          opt:'Junior KG'
      },
      {   id:5,
          opt:'Senior KG'
      },
      {   id:6,
          opt:'Class 1'
      },
      {   id:7,
          opt:'Class 2'
      },
      {   id:8,
          opt:'Class 3'
      },
      {
          id:9,
          opt:'Class 4'
      },
      {
          id:10,
          opt:'Class 5'
      },
      {
          id:11,
          opt:'Class 6'
      },
      {
          id:12,
          opt:'Class 7'
      },
      {
          id:13,
          opt:'O Level'
      },
      {
          id:14,
          opt:'A Level'
      },
      {
          id:15,
          opt:'Pre- O level'
      },
    
    ];
    const optionsShowt = [
      {
        id:0,
        opt:"Select"
      }
      ,{
        id:1,
        opt:10
      },
      {
        id:2,
        opt:20
      },
      {
        id:3,
        opt:30
      },
    ]
    const [mainpagesearch,setmainpagesearch] = useState("")
    const handlemainpagesearch=(e)=>{
      setmainpagesearch(e.target.value)
    }
    const [statusvalueerr,setstatusvalueerr] = useState("")
    const [activefromMoment,setactivefromMoment] = useState("")
  
    useEffect(()=>{
      var date = moment("2017-07-11")
        var now = moment("2020-07-12");
  
        if (now > date) {
          console.log("past")
        } else {
          console.log("future")
        }
    },[])
    const [classdrp,setClassdrp] = useState("")
    const drpfuncExam=(myroleval,myid)=>{
      setExamdrp(myroleval)    
    }
    const drpfuncClass=(myval,myid)=>{
      setClassdrp(myval)    
    }
      const [show3, setShow3] = useState(false);
      const [modalitem,setmodalitem] = useState(null)
      const handleShow3 = (e,myitem) =>{
        setShow3(true)
        setmodalitem(myitem)
        setrolemodalvalue2(myitem.rolename)
        console.log(rolemodalvalue2)
      };
  
    const [currentItems, setCurrentItems] = useState([]);
    const [currentItemsmodel, setCurrentItemsmodel] = useState(null);
    const [pageCount, setPageCount] = useState(0);
    const [pageCountfiltered, setPageCountfiltered] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
    const [itemsPerPage,setitemsPerPage] = useState(10);
    const [paginatenumselected,setpaginatenumselected] = useState(0)
    const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
    const [pageCount2, setPageCount2] = useState(0);
    const [itemOffset2, setItemOffset2] = useState(0);
    const [itemsPerPage2,setitemsPerPage2] = useState(10);
    
    const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
    const [paginatenumselected2,setpaginatenumselected2] = useState(0)
    const [filteredArr,setfilteredArr] = useState(AttendanceReportApi.data)
  
    const mainfilter=(searchkey,myrole,myactivefromdate,myactivetodate,arr)=>{    
      
      let filteredArr = [];
  
  
      if (searchkey && examDrp && examDrp !== "All") {
          filteredArr = arr.filter((item) => {
            const roleMatch = item.exam.toLowerCase() === examDrp.toLowerCase();
            const searchMatch = item.class.toLowerCase().includes(searchkey.toLowerCase());
            return roleMatch && searchMatch;
          });
        
        } else if ((searchkey && examDrp == "") || (searchkey && examDrp == "All")) {
          filteredArr = arr.filter((item) => {
            return item.class.toLowerCase().includes(searchkey.toLowerCase());
          });
        } else if (examDrp && examDrp !== "All" && searchkey=="") {
          filteredArr = arr.filter((item) => {
            return item.exam.toLowerCase() === examDrp.toLowerCase();
          });
        } else  {
          filteredArr = arr.filter((item) => {
            return item;
          });
        }
  
  
  setfilteredArr(filteredArr);
      
    }
  
  
  
    const [tempfilteredarr,settempfilteredarr] = useState([])
      useEffect(() => {
          // Fetch items from another resources.
          const endOffset = itemOffset + itemsPerPage;        
          setCurrentItems(AttendanceReportApi.data.slice(itemOffset, endOffset));        
          setPageCount(Math.ceil(AttendanceReportApi.data.length / itemsPerPage));
          
        }, [itemOffset, itemsPerPage]);
        let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
        useEffect(()=>{
          const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
          settempfilteredarr(filteredArr.slice(itemOffsetfiltered, endOffsetfiltered));
          setPageCountfiltered(Math.ceil(pagecountoffilter / itemsPerPagefiltered));
          setpagecountoffilter(filteredArr.length)
        },[itemOffsetfiltered,itemsPerPagefiltered,filteredArr,tempfilteredarr])
      
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
          const newOffset = event.selected * itemsPerPage % AttendanceReportApi.data.length;        
          setpaginatenumselected(event.selected);
          setItemOffset(newOffset);
        };
        const handlePageClickfiltered = (event) => {
          const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
          setpaginatenumselectedfiltered(event.selected);
          setItemOffsetfiltered(newOffsetf);
        };
      useEffect(() => {
          // Fetch items from another resources.
          const endOffset2 = itemOffset2 + itemsPerPage2;        
          setCurrentItemsmodel(menumgmtApi.data.slice(itemOffset2, endOffset2));
          setPageCount2(Math.ceil(menumgmtApi.data.length / itemsPerPage2));
        }, [itemOffset2, itemsPerPage2]);
      
        // Invoke when user click to request another page.
        const handlePageClickmodel = (event) => {
          const newOffset2 = event.selected * itemsPerPage2 % menumgmtApi.data.length;
          
          setpaginatenumselected2(event.selected);
          setItemOffset2(newOffset2);
        };
        
        const [rolemodalvalue,setrolemodalvalue] = useState("")
        const [rolemodalvalue2,setrolemodalvalue2] = useState("")
        const drpfuncrolemodal=(myid,mystatus)=>{
          setrolemodalvalue(mystatus)
          
            
        }
        const drpfuncrolemodal2=(mystatus,myid)=>{
          setrolemodalvalue2(mystatus)
          console.log("manualselect" , mystatus)
            
        }
        
        const handlesearch =()=>{
      
          setactivefrom("")
        
      }
  
      
  
      const [searchinputmodal,setsearchinputmodal] = useState("")
      const [rolesearchkey,setrolesearchkey] = useState("")
      const handlesearchinputmodal=(e)=>{
        setsearchinputmodal(e.target.value)      
      }
      const handlesearchmodal=()=>{
        setrolesearchkey(searchinputmodal)
      }
      const drpfuncshow=(myshow,id)=>{
        setShow(myshow)
        
      }
      
      const [ischkmodal,setischkmodal] = useState(false)
      const handleChangechk = event => {
        if (event.target.checked) {
          console.log('✅ Checkbox is checked');
        } else {
          console.log('⛔️ Checkbox is NOT checked');
        }
        setischkmodal(current => !current);
      };
    
  
     
     
  
      useEffect(()=>{
        
          mainfilter(mainpagesearch,examDrp,activefrom,activeto,AttendanceReportApi.data)      
  
        
      },[mainpagesearch,examDrp,activefrom,activeto])
      
      const handleActiveFrom = (activefromval)=>{
  
          if(activefromval != null){
            
              var dtmnt = activefromval.$M + 1;
              var dtfinalc = activefromval.$y + '-'+ dtmnt +'-'+ activefromval.$D;
             
              var tt = moment(dtfinalc,'YYYY-MM-DD').calendar() 
              console.log(tt - moment("2023-06-12",'YYYY-MM-DD').calendar())
              console.log(dtfinalc)
              setactivefrom(dtfinalc)
          }
          
          
      }
        const handleActiveTo = (activetoval)=>{
      
          if(activetoval != null){
      
              var dtmnt = activetoval.$M + 1;
              var dtfinalc = activetoval.$y + '-'+ dtmnt +'-'+ activetoval.$D;
              var dd = moment(activeto,'YYYY-MM-DD').calendar() - moment(dtfinalc,'YYYY-MM-DD').calendar() 
              setactiveTo(dtfinalc)
  
              
          }
          
          
      }
  
  return (
    <>
          <div className="felxvaluecompmbmain">
              <div className="studentdashboardmobilewrapper">
                  <div className="mobilecontainer">
                      <div className="adminmbheading">
                          <h3>Staff Monthly Attendance</h3>
                      </div>
                      <div className="admbwrap bt0">
                          <Row>
                              <Col xs={6} className="pr5">
                              <div className="basicinput">
                                    <p>Department</p>
                                    <div className="dropdownwrapper">

                                        <Dropdown2 func={drpfuncExam} myplaceholder="Select Exam" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsdept} />
                                    </div>
                                </div>
                              </Col>
                              <Col xs={6} className="pl5">
                               <div className="basicinput">
                                    <p>Campus</p>
                                    <div className="dropdownwrapper">

                                        <Dropdown2 func={drpfuncClass} myplaceholder="Select Class" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsCampus} />
                                    </div>
                                </div>
                              </Col>
                              <Col xs={6} className="pr5">
                              <div className="basicinput">
                                    <p>Period</p>
                                    <div className="dropdownwrapper">

                                        <Dropdown2 func={drpfuncExam} myplaceholder="Select Section" fontsize="16" fontfamily="'Poppins', sans-serif" options={optionsPeriod} />
                                    </div>
                                </div>
                              </Col>
                              <Col xs={6}></Col>
                              <Col xs={6} className="pr5">
                               <div className="basicinput">                                    
                                    <button className='cmbutton'>
                                    Search
                                    </button>
                                </div>
                              </Col>
                              <Col xs={6} className="pl5">
                                <div className="basicinput">                                    
                                    <button className='cmbutton'>Print</button>
                                </div>
                              </Col>
                              <Col xs={6} className="pr5">
                              <div className="basicinput">                                    
                                    <button className='cmbutton'>
                                    Print Excel
                                    </button>
                                </div>
                              </Col>
                              <Col xs={6} className="pl5">
                                <div className="basicinput">                                    
                                    <button className='cmbutton'>Process</button>
                                </div>
                              </Col>
                          </Row>
                      </div>
                      <div className="admbwrap">
                        <div className="tablewrapscroll">
                        <div className="flexvaluetable">
                    <table>
                      <thead>
                        <tr>
                            {
                              AttendanceReportApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            filteredArr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.sl}</td>
                                  <td>{item.id}</td>
                                  <td>{item.name}</td>
                                  <td>{item.designation}</td>
                                  <td>{item.wd}</td>
                                  <td>{item.late}</td>
                                  <td>{item.earlyleave}</td>
                                  <td>{item.absentdateandday}</td>
                                  <td>{item.deductionforlate}</td>
                                  <td>{item.deductionforearlyleave}</td>
                                  <td>{item.leavewithoutpay}</td>
                                  <td>{item.tottaldeduction}</td>
                                  <td>{item.totalpayable}</td>
                                  <td>{item.remark}</td>
                                  
                                </tr>
                              )
                            })
                            :
                            
                             currentItems.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.class}</td>
                                  <td>{item.section}</td>
                                  <td>{item.subject}</td>
                                  <td>{item.subgroup}</td>
                                  <td>{item.event}</td>
                                  <td>{item.teacher}</td>
                                  
                                  <td>
                                    <div className="img text-center">
                                      <img onClick={(e)=> handleShow3(e,item)} src={item.action} alt="" />  
                                    </div>  
                                  </td>
                                </tr>
                              )
                            })
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>                  
                        </div>
                      </div>
                        <div className="admbwrap">
                        <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">

                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft text-center'>Showing {itemOffset+1} to {itemOffset+10} of {AttendanceReportApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                    <div className="paginationwrapper">
                        
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="prev"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                    </div>
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
                        </div>
                  </div>
              </div>
          </div>
    </>
  )
}

export default AttendancereportCompmb